import React, { useCallback, useState } from 'react'
import {
  Anchor, Box, Text, WrenchIcon, ShowIfDesktop,
  ShowIfNotDesktop as ShowIfMobile,
  Modal,
} from '@usap/uicomponents'
import { useFeatureFlagCookieContext } from '@usap/core'
import { PopUpLayer, Title } from '@usap/widgets'
import { GTM } from '../../helpers'
import InstallationQuotesPopupContent from './InstallationQuotesPopupContent'
import { BoxStyled, IcoMoonStyled, TextInfoStyled } from './InstallationQuotes.css'
import useWmoEnabled from '../../hooks/useWmoEnabled'
import InstallationQuotesWmo from './InstallationQuotesWmo'
import InstallationQuotesPopupContentWmo from './InstallationQuotesPopupContentWmo'

const InstallationQuotes = ({ skuTitle, show = true, location = '' }) => {
  const desktopLearnMoreTrackerID = `desktop-difm2-learn-more-${location}`
  const mobileLearnMoreTrackerID = `wom-difm2-learn-more-${location}`
  const { learnMoreRepairQuote } = GTM
  const [onShow, setOnShow] = useState(false)
  const { difm: hasInstallationQuotesFlag } = useFeatureFlagCookieContext()
  const isWmoEnabled = useWmoEnabled()

  const onCloseCallback = useCallback(
    () => {
      setOnShow(false)
    },
    [setOnShow],
  )

  const onLearnMore = useCallback(
    () => {
      setOnShow(true)
      learnMoreRepairQuote(skuTitle)
    },
    [learnMoreRepairQuote, skuTitle],
  )

  if (!hasInstallationQuotesFlag || !show) {
    return null
  }

  if (location === 'cart' && isWmoEnabled) {
    return (
      <InstallationQuotesWmo
        desktopLearnMoreTrackerID={desktopLearnMoreTrackerID}
        mobileLearnMoreTrackerID={mobileLearnMoreTrackerID}
        onLearnMore={onLearnMore}
        onCloseCallback={onCloseCallback}
        showModal={onShow}
      />
    )
  }

  return (
    <>
      <BoxStyled id="installation-quotes" color="dark-2">
        <IcoMoonStyled size="33px" icon={WrenchIcon} color="#333333" />
        <Box pad="small">
          <Title
            weight="bold"
            size="small"
            color="dark-2"
            label="Want help with installation?"
          />
          <TextInfoStyled size="xsmall">
            Our dedicated team will gather quotes from certified technicians in
            your area and help you find the right fit at the best rate.
            {' '}
            <Anchor
              size="small"
              onClick={onLearnMore}
              label={(
                <>
                  <ShowIfDesktop>
                    <Text size="xsmall" weight="normal" color="#2e6b9e" data-testid={desktopLearnMoreTrackerID}>
                      Learn More
                    </Text>
                  </ShowIfDesktop>
                  <ShowIfMobile>
                    <Text size="xsmall" weight="normal" color="#2e6b9e" data-testid={mobileLearnMoreTrackerID}>
                      Learn More
                    </Text>
                  </ShowIfMobile>
                </>
              )}
            />
          </TextInfoStyled>
        </Box>
      </BoxStyled>

      {isWmoEnabled
        ? (
          <Modal
            open={onShow}
            onOpenChange={onCloseCallback}
            content={<InstallationQuotesPopupContentWmo />}
            header="Find the Right Part and the Right Shop"
          />
        )
        : (
          <PopUpLayer
            flag={onShow}
            closePopUp={onCloseCallback}
            PopUpComponent={InstallationQuotesPopupContent}
            onCloseCallback={onCloseCallback}
            isClose={false}
            fitMobileWidth
          />
        )}
    </>
  )
}

/*
 * The React.mere here is intended to memorize the component
 * in case the user opens the popup more than one time without changing the props.
 */
export default React.memo(InstallationQuotes)
